import React,{useEffect, useState, useRef, useCallback} from 'react';
import { useDispatch, useSelector } from "react-redux";
import style from "./BetDetailPage.module.css";
import { setHeader } from '../../store/settings/settingsSlice';
import teamLogo from "../../assets/images/favAlone-02.png";
import copy_icon from "../../assets/images/save-2.svg";
import Lottie from "lottie-react";
import loader from "../../assets/lottie/loader.json";
import send_icon from "../../assets/images/send-outline.svg";
import spin_circle from '../../assets/images/Loader anim.png'
import success_icon from '../../assets/images/success-icon.svg';
import {  Profile2User} from "iconsax-react";
import { useParams, useNavigate } from "react-router-dom";
import { getQuestionDetails, getRelatedMarkets, placeBet } from '../../store/prediqo/prediqoActions';
import { ArrowDown2,Calculator} from "iconsax-react";
import us_icon from "../../assets/images/us.svg";
import ng_icon from "../../assets/images/ng.svg";
import ghana_icon from "../../assets/images/ghanaflag.svg";
import tick_icon from "../../assets/images/tick-greencircle.svg";
import chart_icon from "../../assets/images/chart.svg";
import PinInput from "react-pin-input";
import cogoToast from 'cogo-toast';
import Modal from '../modal/Modal';
import { fetchExchangeConfig, getWalletBalance } from '../../store/wallet/walletActions';


const BetDetailPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { betId } = useParams();
    const [betDetails, setBetDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const walletData = useSelector((state) => state.wallet.data);
    const exchangeConfig = useSelector((state) => state.wallet.exchangeConfig);
    const relatedMarkets = useSelector((state) => state.prediqo.relatedMarkets);
    console.log(relatedMarkets)
    const relatedMarketsLoading = useSelector((state) => state.prediqo.relatedMarketsLoading);

    const [isPredictionModal, setIsPredictionModal] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    const [sourceWallet, setSourceWallet] = useState('');
    const [betAmount, setBetAmount] = useState('');
    const [trPin, setTrPin] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [openFromWallet, setOpenFromWallet] = useState(false);
    
    const [betSuccessModal, setBetSuccessModal] = useState(false);
    const [putPass, setPutPass] = useState(false);
    let ele = useRef();
    const [convertedMinBet, setConvertedMinBet] = useState(0);
    const [convertedMaxBet, setConvertedMaxBet] = useState(0);
    const [potentialReturn, setPotentialReturn] = useState(0);
    

    // Store selected option details for API call
    const [selectedWalletId, setSelectedWalletId] = useState(null);
    const [selectedPrediction, setSelectedPrediction] = useState(null);


   const fetchBetDetails = useCallback(async () => {
      if(!betId) {
        navigate("/dashboard");
        return;
      }
      try {
          setLoading(true);
          const response = await dispatch(getQuestionDetails({
            id: betId
          })).unwrap();
          setBetDetails(response.data.question);
      } catch (err) {
          setError(err.message || "Failed to fetch question details");
      } finally {
          setLoading(false);
      }
    }, [betId, dispatch, navigate]);

 // Helper function to get currency symbol
    const getCurrencySymbol = (currency) => {
        switch (currency) {
            case 'NGN': return '₦';
            case 'GHS': return '₵';
            case 'USD': return '$';
            default: return '$';
        }
    };

      // Helper function for currency conversion (similar to Exchange.jsx)
        const convertCurrency = useCallback((amount, fromCurrency = 'USD', toCurrency) => {
            if (!exchangeConfig || !toCurrency || fromCurrency === toCurrency) {
                return amount;
            }
    
            // Find the exchange rate for the target currency
            const exchangeRateData = exchangeConfig.find(
                (rate) => rate.BaseCurrency.code === fromCurrency && rate.TargetCurrency.code === toCurrency
            );
    
            if (exchangeRateData) {
                return amount * parseFloat(exchangeRateData.exchange_rate);
            }
            
            return amount;
        }, [exchangeConfig]);
    

       // Wallet handlers (copied from VirtualCards)
       const toggleFromWallet = () => {
           setOpenFromWallet(!openFromWallet);
       };

          // Format number with commas
    const formatNumberWithCommas = (value) =>
        new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);

        const handleFromWallet = (e) => {
            console.log(e.target.id)
        const selectedCurrency = e.target.textContent;
        const walletId = e.target.id;
        setOpenFromWallet(false);
        setSourceWallet(selectedCurrency);
        setSelectedWalletId(parseInt(walletId));
        setBetAmount('');
        setPotentialReturn(0);
        setErrorMessage("");
        
        // Trigger conversion calculation when wallet is selected
        if (betDetails) {
            const minConverted = convertCurrency(betDetails.min_bet_value, 'USD', selectedCurrency);
            const maxConverted = convertCurrency(betDetails.max_bet_value, 'USD', selectedCurrency);

            setConvertedMinBet(minConverted);
            setConvertedMaxBet(maxConverted);
        }
    };

     const handleAmountChange = (e) => {
        const inputAmount = e.target.value;
        setBetAmount(inputAmount);

        if (!sourceWallet) {
            setErrorMessage("Please select a source wallet.");
            return;
        }

        // Check minimum bet validation with currency conversion
        if (inputAmount && parseFloat(inputAmount) < convertedMinBet) {
            setErrorMessage(`Amount cannot be less than minimum bet of ${getCurrencySymbol(sourceWallet)}${convertedMinBet.toFixed(2)}`);
            return;
        }

        // Check maximum bet validation with currency conversion
        if (inputAmount && parseFloat(inputAmount) > convertedMaxBet) {
            setErrorMessage(`Amount cannot exceed maximum bet of ${getCurrencySymbol(sourceWallet)}${convertedMaxBet.toFixed(2)}`);
            return;
        }

        // Check wallet balance
        const walletBalance = walletData?.fiatWallets.find(wallet => 
            sourceWallet.includes(wallet.Currency.code))?.balance || 0;
        
        if (inputAmount && parseFloat(inputAmount) > parseFloat(walletBalance)) {
            setErrorMessage(`Insufficient balance. Available: ${getCurrencySymbol(sourceWallet)}${walletBalance}`);
            return;
        }

        setErrorMessage("");
        
        // Recalculate potential return when amount changes
        if (selectedOption && inputAmount) {
            const cleanAmount = parseFloat(inputAmount);
            const potential = cleanAmount * parseFloat(selectedOption.odd);
            setPotentialReturn(potential);
        }
    };


    const handlePinSubmit = async () => {
        if (!trPin || trPin.length < 5) {
            // You can add error handling here
            return;
        }
    
        if (!selectedOption || !selectedWalletId || !betAmount) {
            // Handle missing information
            return;
        }
    
        // Close pin modal and show loading
        setPutPass(false);
        setIsPredictionModal(false);
        setIsOpen(true);
    
        try {
            // Dispatch the place bet action
            await dispatch(placeBet({
                questionId: betDetails.id,
                optionId: selectedOption.id,
                transactionPin: trPin,
                walletId: selectedWalletId,
                amount: parseFloat(betAmount)
            })).unwrap();
    
            // Success - show success modal
            setIsOpen(false);
            setBetSuccessModal(true)
                  
            // Reset all form states
            resetBettingForm();
        
        } catch (error) {
            // Error handling
            setIsOpen(false);
        
          // Reopen the pin modal for retry
            setPutPass(true);
    
            // You can show an error message here
            console.error("Bet placement failed:", error);
        }
    };

    // Importing the setHeader action from the headerSlice
    useEffect(() => {
        fetchBetDetails();
        dispatch(getWalletBalance());
        dispatch(fetchExchangeConfig());
        dispatch(setHeader("Bet Detail"));
    }, [dispatch, betId, fetchBetDetails]);

    useEffect(() => {
    if (betId) {
        dispatch(getRelatedMarkets({
            bet_category_id: betId
        }));
    }
    }, [dispatch, betId]);

  const resetBettingForm = () => {
    setIsPredictionModal(false);
    setSelectedPrediction(null);
    setBetAmount('');
    setSourceWallet('');
    setErrorMessage('');
    setPotentialReturn(0);
    setSelectedWalletId(null);
    setTrPin('');
    setPutPass(false);

    // Clear pin input only on success
    if (ele && ele.clear) {
        ele.clear();
    }
  };

        const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
             hour: '2-digit',
              minute: '2-digit',
              hour12: false
        });
    };

    // const calculateChance = (odd) => {
    //     return Math.round((1 / parseFloat(odd)) * 100);
    // };

    const copyToClipboard = () => {
      navigator.clipboard.writeText(window.location.href);
        cogoToast.success("Copied to Clipboard", {
          position: "top-right",
        });
  // You can add a toast notification here
    };

   const shareLink = () => {
        if (navigator.share) {
            navigator.share({
                title: betDetails?.question_text,
                url: window.location.href,
            });
        } else {
            copyToClipboard();
        }
    }


    if (loading) {
        return (
            <div className={style.loadingContainer}>
                <div className={style.lottieWrap}>
                  <Lottie
                    style={{
                      width: "70px",
                      height: "70px",
                      color: "#fff",
                      padding: "0px",
                      margin: "0px",
                    }}
                    animationData={loader}
                    loop={true}
                  />
                </div>
                {/* <img src={spin_circle} alt="loading" className={style.animate_spin} /> */}
                <p>Loading bet details...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className={style.errorContainer}>
                <p>Error: {error}</p>
                <button onClick={() => navigate(-1)} className={style.backButton}>
                    Go Back
                </button>
            </div>
        );
    }


    if (!betDetails) {
        return (
            <div className={style.errorContainer}>
                <p>Bet not found</p>
                <button onClick={() => navigate(-1)} className={style.backButton}>
                    Go Back
                </button>
            </div>
        );
    }

    // Get the betting options - handle multiple option groups
    const betOptions = betDetails.BetOptions || [];
    
    // For calculating the main chance percentage, use the first "yes" option found
    // const firstYesOption = betOptions.length > 0 ? 
    //     betOptions[0].options?.find(opt => opt.bet_side === 'yes') : null;


    return ( 
        <>
        {/* PREDICTION BETTING MODAL */}
        <Modal
        canClose={true}
        modalOpen={isPredictionModal}
        setModalOpen={setIsPredictionModal}
        title=""
        minWidth='40%'
        >
        {selectedOption && (
            <div className={style.predictionModalContent}>
            <div className={style.predictionModalHeader}>
                <h3 className={style.modalTitle}>{betDetails.question_text}</h3>
            
            </div>

            <div className={style.bettingOptionsSection}>
                <div className={style.groupOptions}>
                <div
                    className={`${selectedOption.bet_side === "yes" ? style.modalActiveOptionYes : style.modalActiveOptionNo}`}
                    style={{cursor: 'pointer', position: 'relative'}}
                >
                    <span style={{textTransform: 'capitalize'}}>{selectedOption.bet_side}</span>
                    <strong className={selectedOption.bet_side === "yes" ? style.activeOptionYesStrong : style.activeOptionNoStrong}>
                    {selectedOption.odd}
                    </strong>
                    {selectedOption.is_cash_out_active && (
                    <small style={{marginLeft: 8, color: "#40196D"}}>Cash out available</small>
                    )}
                </div>
                </div>
            </div>

            
                <div className={style.labelPut} style={{marginTop: '15px', marginBottom: '0px'}}>
                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                        <label htmlFor="from_wallet" className={style.formLabel}>Fund From</label>
                        {sourceWallet && (
                        <p style={{margin: '0px', color: '#40196D', fontWeight: 500, fontSize: 14}}>
                            Bal: {sourceWallet === "NGN" ? '₦' : sourceWallet === "GHS" ? '₵' : '$'}
                            {walletData?.fiatWallets?.find(wallet => sourceWallet === wallet.Currency.code)?.balance || '0.00'}
                        </p>
                        )}
                    </div>

                    <div className={style.select} style={{marginTop: '10px'}}>
                        <div id="from_wallet"
                            onClick={toggleFromWallet}
                            name="from_wallet" className={style.selectInput}>
                            <div className={style.walletDiv}>
                                {sourceWallet && (
                                    <img
                                        style={{ width: "20px", height: '20px', borderRadius: '50%'}}
                                        src={sourceWallet === "NGN" ? ng_icon : sourceWallet === "GHS" ? ghana_icon : sourceWallet === "USD" ? us_icon: ""} 
                                        alt="country icon" 
                                    />
                                )}
                                <p style={{fontWeight: `${sourceWallet ? 600: 400}`, marginBottom: '0px'}} className={style.walletTitle}>
                                    {sourceWallet ? sourceWallet : 'Select wallet'}
                                </p>
                            </div>
                
                                <ArrowDown2
                                    style={{
                                        transform: openFromWallet === true
                                            ? "translateY( -50%) rotate(-540deg)"
                                            : "translateY( -50%) rotate(0deg)",
                                        pointerEvents: "none",
                                    }}
                                    className={style.dropDown}
                                    size="20"
                                    color="#909090"
                                    variant="Bold"
                                />
                            </div>
                            <div
                                style={{
                                height: openFromWallet === true ? "fit-content" : "0px",
                            }}
                            className={style.option}
                        >
                            {walletData ? (
                                walletData.fiatWallets.map((item, index) => (
                                    <p
                                        id={item.id}
                                        key={item.id}
                                        style={{
                                            borderBottom: walletData.fiatWallets.length - 1 === index ? "none" : "1px #90909039 solid;",
                            }}
                                        onClick={(e) => {
                                            handleFromWallet(e);
                                        }}
                                    >
                                        {item.Currency.code}
                                    </p>
                                ))
                            ) : (
                                <p>Sorry, no wallets here</p>
                            )}
                        </div>
                    </div>            
                </div>

                
                <div className={style.labelPut} style={{marginTop: '15px', marginBottom: '0px'}}>
                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                        <label htmlFor="amount">Amount<span style={{color:'#FF0000'}}>*</span></label>
                        {sourceWallet && (
                            <div style={{textAlign: 'right'}}>
                                <span style={{
                                    color: '#40196D', 
                                    fontSize: '12px', 
                                    fontWeight: '500',
                                    display: 'block'
                                }}>
                                    Min: {getCurrencySymbol(sourceWallet)}{formatNumberWithCommas(convertedMinBet.toFixed(2))}
                                </span>
                                <span style={{
                                    color: '#40196D', 
                        fontSize: '12px', 
                        fontWeight: '500'
                    }}>
                        Max: {getCurrencySymbol(sourceWallet)}{formatNumberWithCommas(convertedMaxBet.toFixed(2))}
                    </span>
                        </div>
                    )}
                    </div>
                <div className={style.input}>
                    <input
                type="number"
                name="amount"
                placeholder={`Enter amount (Min: ${getCurrencySymbol(sourceWallet || 'USD')}${sourceWallet ? formatNumberWithCommas(convertedMinBet.toFixed(2)) : selectedPrediction?.min_bet_value || 0})`}
                value={betAmount}
                onChange={handleAmountChange} 
                min={convertedMinBet}
                            max={convertedMaxBet}
                            step="0.01"
                        />
                        {errorMessage && <p style={{ color: "#FF0000", fontSize: '12px', marginTop: '5px', textAlign:'left', marginBottom: '0px' }}>{errorMessage}</p>}
                    </div>
                </div>

                {/* Potential Return */}
                <div className={style.potentialReturn}>
                    <Calculator size="20" color="#40196D" />
                    <span>Potential Return = {sourceWallet} {formatNumberWithCommas(potentialReturn.toFixed(2))}</span>
                </div>

            <button 
                className={style.reviewButton}
                onClick={() => {
                if (!sourceWallet) {
                    setErrorMessage('Select a wallet');
                    return;
                }
                const amt = parseFloat(betAmount);
                if (!amt || amt < betDetails.min_bet_value || amt > betDetails.max_bet_value) {
                    setErrorMessage('Enter a valid amount within limits.');
                    return;
                }
                setIsPredictionModal(false);
                setPutPass(true);
                }}
                disabled={
                !betAmount || 
                !sourceWallet || 
                parseFloat(betAmount || 0) < betDetails.min_bet_value || 
                parseFloat(betAmount || 0) > betDetails.max_bet_value ||
                !!errorMessage
                }
            >
                Review
            </button>
            </div>
        )}
        </Modal>

          {/* MODAL FOR TRANSACTION PIN */}
        <Modal canClose={true} modalOpen={putPass} setModalOpen={setPutPass}>
            <div className={style.setTrPin}>
            <h2 className={style.pinHead}>Transaction Pin</h2>
            <p style={{textAlign: 'left'}}>Please input your transaction pin</p>
            <div className={style.inputs2}>
                <PinInput
                length={5}
                initialValue=""
                secret={true}
                ref={(n) => {
                    ele = n;
                }}
                onChange={(value, index) => {
                    setTrPin(value);
                }}
                type="numeric"
                inputMode="number"
                style={{ padding: "10px", margin: "0 auto 0 auto" }}
                inputStyle={{ border: "1px solid", borderColor: "#909090" }}
                inputFocusStyle={{
                    border: "2px solid",
                    borderColor: "#40196D",
                }}
                onComplete={(value, index) => {
                    setTrPin(value);
                }}
                autoSelect={true}
                regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                value={trPin}
                />
            </div>
            <button
                className={style.save}
                onClick={handlePinSubmit}
            >
                Place Bet
            </button>
            </div>
        
        </Modal>

          {/* Loading Modal */}
         <Modal
        canClose={false}
        modalOpen={isOpen}
        setModalOpen={setIsOpen}
      >
        <div>
            <div style={{display: 'flex', justifyContent: 'center', marginTop: '25px'}}>
                <img src={spin_circle} alt="spin circle" className={style.animate_spin} />
            </div>

            <div>
                <h4 style={{color: '#40196D', fontWeight: '600', marginTop: '25px'}}>
                    Placing your bet
                 </h4>
                <p style={{color: '#B6B6B6', maxWidth:'300px', margin: 'auto', marginTop: '15px'}}>
                  Please wait...
                </p>
               
            </div>
        </div>

        </Modal>


        {/* Success Modal */}
        <Modal
            title='Bet Placed Successfully'
            minWidth='30%'
            canClose={true}
            modalOpen={betSuccessModal}
            setModalOpen={setBetSuccessModal}
        >
           <div>
            <div style={{display: 'flex', justifyContent: 'center', marginTop: '25px'}}>
                <img src={success_icon} alt="spin circle" />
            </div>

            <div>
            
                <p style={{color: '#B6B6B6', maxWidth:'300px', margin: 'auto', marginTop: '15px'}}>
                     Your bet was successfully placed.
                        You’ll be notified after the bet due date.
                </p>
            </div>

            <button onClick={() => setBetSuccessModal(false)} style={{marginTop: '20px'}} className={style.save}>
               Place Another Bet
            </button>

        </div>
        </Modal>

        <div className={style.container}>
        <div className={style.card}>
            <div className={style.header}>
            <div className={style.probability}>
                <img 
                    src={betDetails.image_url || teamLogo} 
                    alt="icon" 
                    className={style.icon} 
                />
                <p className={style.percent}>
                {betDetails.question_text}
                </p>
            </div>
            <div className={style.meta}>
                <img src={copy_icon} alt="copy icon" style={{cursor: 'pointer'}} onClick={copyToClipboard} />
                <img src={send_icon} alt="send icon" style={{cursor: 'pointer'}} onClick={shareLink} />
            </div>
            </div>

            <div className={style.subheader}>
            <div className={style.chanceSection}>
                {/* <p className={style.chanceLevel}>
                {firstYesOption ? calculateChance(firstYesOption.odd) : 0}%
                </p>
                <p className={style.chanceText}>Chance</p> */}
            </div>
            <div >
                <div style={{display: "flex", alignItems: "flex-end", gap: "5px"}}>
                <Profile2User size="16" />
                <p style={{color: '#212121', opacity: '50%'}}>
                    {betDetails.user_count}
                </p>
                </div>
                <p style={{fontSize: '12px', marginTop: '5px', opacity: '50%'}}>Ends {formatDate(betDetails.end_time)}</p>
            </div>
            </div>

            {/* Bet Information */}
            <div className={style.betInfo}>
                <div className={style.infoGrid}>
                    <div className={style.infoItem}>
                        <span>Category:</span>
                        <strong>{betDetails.bet_category}</strong>
                    </div>
                    <div className={style.infoItem}>
                        <span>Min Bet:</span>
                        <strong>${betDetails.min_bet_value}</strong>
                    </div>
                    <div className={style.infoItem}>
                        <span>Max Bet:</span>
                        <strong>${betDetails.max_bet_value}</strong>
                    </div>
                    <div className={style.infoItem}>
                        <span>Market Opens:</span>
                        <strong>{formatDate(betDetails.start_time)}</strong>
                    </div>
                </div>
            </div>

            {/* Betting Options */}
            <div className={style.bettingGroups}>
                {betOptions.map((betOption, index) => {
                    const yesOption = betOption.options?.find(opt => opt.bet_side === 'yes');
                    const noOption = betOption.options?.find(opt => opt.bet_side === 'no');
                    
                    return (
                        <div key={index} className={style.optionGroup}>
                            <h5 className={style.optionGroupTitle}>{betOption?.option_text || 'Bet Option'}</h5>
                            <div className={style.options}>
                                {yesOption && (
                                    <button 
                                    className={style.optionYes}
                                    onClick={() => {
                                        setSelectedOption(yesOption);
                                        setIsPredictionModal(true);
                                        setErrorMessage('');
                                        setBetAmount('');
                                        setSourceWallet('');
                                    }}
                                    >
                                        Yes <span>{yesOption.odd}</span>
                                        {yesOption.is_cash_out_active && (
                                            <small>Cash out available</small>
                                        )}
                                    </button>
                                )}
                                {noOption && (
                                    <button 
                                    className={style.optionNo}
                                    onClick={() => {
                                        setSelectedOption(noOption);
                                        setIsPredictionModal(true);
                                        setErrorMessage('');
                                        setBetAmount('');
                                        setSourceWallet('');
                                    }}
                                    >
                                        No <span>{noOption.odd}</span>
                                        {noOption.is_cash_out_active && (
                                            <small>Cash out available</small>
                                        )}
                                    </button>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>

            <div className={style.section}>
                <h4 className={style.sectionTitle}>Market Details & Rules</h4>
                {betDetails.question_description ? (
                    <div 
                        className={style.htmlContent}
                        dangerouslySetInnerHTML={{ 
                            __html: betDetails.question_description 
                        }}
                    />
                ) : (
                    <p>No description available</p>
                )}
                {betDetails.feedback_on_question && (
                    <div className={style.feedback}>
                        <h5>Additional Information:</h5>
                        <p>{betDetails.feedback_on_question}</p>
                    </div>
                )}
            </div>

            {/* Timelines & Payout Section */}
            <div className={style.timelineSection}>
                <h4 className={style.timelineTitle}>Timelines & Payout</h4>
                <div className={style.timelineList}>
                    <div className={style.timelineItem}>
                        <div>
                            <img src={tick_icon} alt="Tick Icon" />
                        </div>
                        <div>
                            <span className={style.timelineLabelActive}>Market Open</span>
                            <span className={style.timelineDate}>{formatDate(betDetails.start_time)}</span>
                        </div>
                    </div>
                    <div className={style.timelineItem}>
                        <div>
                            <img src={chart_icon} alt="Chart Icon" />
                        </div>
                        <div>
                            <span className={style.timelineLabel}>Market Close</span>
                            <span className={style.timelineDate}>{formatDate(betDetails.end_time)}</span>
                        </div>
                    </div>
                    <div className={style.timelineItem}>
                            <div>
                            <img src={chart_icon} alt="Chart Icon" />
                        </div>
                        <div>
                            <span className={style.timelineLabel}>Payout</span>
                            <span className={style.timelineDate}>{betDetails?.payout_time ? formatDate(betDetails.payout_time) : 'N/A'}</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Related Markets Section */}
        <div className={style.relatedMarketsSection}>
        <h4 className={style.relatedMarketsTitle}>Related Markets</h4>
        <div className={style.relatedMarketsList}>
            {/* Example items, replace with dynamic data if available */}
              {relatedMarketsLoading ? (
                      <p>Loading related markets...</p>
                ) : relatedMarkets && relatedMarkets.length > 0 ? (
                relatedMarkets.map(market => (
                    <div 
                    className={style.relatedMarketItem}
                        style={{ cursor: 'pointer' }}
                     onClick={() => navigate(`/bet-detail/${market.id}`)}
                     key={market.id}>
                        <img src={market.image_url || teamLogo} alt="Market Logo" className={style.relatedMarketLogo} />
                        <div>
                            <p className={style.relatedMarketQuestion}>{market.question_text}</p>
                            {/* You can add chance or other info if available */}
                            <p className={style.relatedMarketChance}>{betDetails.bet_category}</p>
                        </div>
                    </div>
                ))
                ) : (
                <p>No related markets found.</p>
                )}
        </div>
        </div>





        </div>
        </div>  
        </>
     );
}
 
export default BetDetailPage;